module.exports = " <div> <home-search></home-search> <home-news></home-news> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/home/Home.vue
// module id = 190
// module chunks = 0